import {
  Datatype,
  type PlainDatatype,
  PlainDatatypes,
} from '../../../../expressions/datatype/Datatype.ts';

export type AdvancedSelectColumnDatatype = PlainDatatype | Datatype.RichText;

export const AdvancedSelectColumnDatatypes = [
  ...PlainDatatypes,
  Datatype.RichText,
] satisfies AdvancedSelectColumnDatatype[];

/**
 * Interfaccia per le colonne condivisa tra widget advanced select
 */
// TODO Rinominare in IAdvancedSelectColumn (singolare)
export interface IAdvancedSelectColumns {
  id: string;
  label: string;
  type: AdvancedSelectColumnDatatype;
}

export interface IPlainAdvancedSelectColumn extends IAdvancedSelectColumns {
  type: PlainDatatype;
}

export function isPlainAdvancedSelectColumn(
  column: IAdvancedSelectColumns,
): column is IPlainAdvancedSelectColumn {
  return column.type !== Datatype.RichText;
}
